<template>
    <section class="cta-area cta-bg news newsLetter-bg" >
        <div class="overlay"></div>
        <div class="container pd-100">
            <div class="row justify-content-center text-center">
                <div class="col-lg-12">
                    <div class="section-title cta-title">
                        <p>{{$t('StoreFront.Newsletter')}}</p>
                        <h2>{{$t('StoreFront.newslettertitle')}}</h2>
                        <Form autocomplete="off" @submit="onSubmit" :validation-schema="schema" v-slot="{errors}" class="bg-body d-flex">
                            <Field type="text" name="emailname" v-model="emailValuecomp.EmailValue"
                                   :class="{ 'form-control' : true ,'is-invalid': errors.emailname }"
                                   :placeholder="$t('StoreFront.EnterEmail')" />                            
                            <div class="invalid-feedback">{{errors.emailname}}</div>
                            <button type="submit" class="btn btn-dark"><i class="fas fa-paper-plane"></i> {{$t('StoreFront.Subscribe')}}</button>
                        </Form>
                    </div>

                </div>

            </div>
        </div>
    </section>
</template>
<script>
    import { Form, Field } from 'vee-validate';
    export default {
        components: {
            Form, Field
        },
        props: ['schema','emailValuecomp'],
        emits: ["submitNewsLetter"],
        data() {
            return {
                showForm: true
            }
        },
        methods: {
            onSubmit() {
                this.$emit("submitNewsLetter", this.emailValuecomp.EmailValue);
            }
        }
    }
</script>